import { Component, OnInit, Input } from '@angular/core';
import { PageService } from 'src/app/services/page.service';

@Component({
  selector: 'app-hero',
  templateUrl: './hero.component.html',
  styleUrls: ['./hero.component.sass']
})
export class HeroComponent implements OnInit {

  @Input() title = '';

  constructor(private pageService:PageService) { }

  ngOnInit(): void {
  }

  cap(s:string): string {
    s = s.split(/[?%#]+/)[0];
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  currentHeader() {
    return this.pageService.getCurrentHeader();
  }
}
